import { looksLikeNetworkTarget } from '@/lib/bhooklyAppPrint'

/**
 * F-FE-N155. `kitchen_stations.printer_target` is one column that means a
 * Windows printer name to the desktop and a LAN ip:port to the Server APK, so
 * the desktop form keeps them as two fields: the device goes to this machine's
 * local map, the address goes to the backend. Off the desktop there is one
 * free-text field and it goes to both, as before.
 */
export interface StationTargetFields {
  device: string
  networkTarget: string
}

export function seedStationTargetFields(args: {
  desktop: boolean
  localDevice: string
  existingTarget: string
}): StationTargetFields {
  const local = (args.localDevice || '').trim()
  const existing = (args.existingTarget || '').trim()
  if (!args.desktop) return { device: local || existing, networkTarget: '' }
  const existingIsAddress = looksLikeNetworkTarget(existing)
  return {
    device: local || (existingIsAddress ? '' : existing),
    networkTarget: existingIsAddress ? existing : '',
  }
}

export function stationTargetForSave(args: {
  desktop: boolean
  device: string
  networkTarget: string
}): { backendTarget: string; localDevice: string } {
  const device = (args.device || '').trim()
  if (!args.desktop) return { backendTarget: device, localDevice: device }
  const network = (args.networkTarget || '').trim()
  return { backendTarget: network || device, localDevice: device }
}
